// import Cookies from 'js-cookie';
import * as helpers from '../../../classes/utils/helpers';

export default class Tracking {
  data = {
    referrer: null,
    pageUrl: null
  };
  isGTMAlreadyLoaded = false;
  etData = {
    sessionId: null,
    userId: null,
    visitId: null,
    p4etoken: null
  };

  constructor(data = {}) {
    if (!data.referrer) {
      data.referrer = helpers.getReferrer();
    }
    if (!data.pageUrl) {
      data.pageUrl = helpers.getPageUrl();
    }
    this.addData(data);
  }

  initGTM(w, d, i, s = 'script', l = 'dataLayer') {
    if (!this.isGTMAlreadyLoaded && i) {
      // load gtm
      w[l] = w[l] || [{visitor_type: 'user'}];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      // control visitor_type
      if (['googlebot', 'bingbot', 'msnbot'].some(ua => w.navigator.userAgent.includes(ua))) {
        w[l][0].visitor_type = 'bot';
      }
      let f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
      this.isGTMAlreadyLoaded = true;
    }
    return this.isGTMAlreadyLoaded;
  }

  trackDatalayer(data) {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push(data);
    }
  }

  addData(data){
    this.data = {...this.data, ...data};
    if(Object.keys(this.data).length > 2){
      this.trackDatalayer(this.data);
    }
  }

  async initET(productName, versionNumber, etUrl = 'https://www.curabox.de/et/get-session-data') {
    if (typeof productName === 'undefined') {
      console.error('Storybook', 'initET needs an productName');
      return false
    }
    if (!this.etData.userId) {
      const etUid = helpers.getEtUid();
      const etUrlParam = (etUid === null) ? '' : `&etuid=${etUid}`;
      this.addData({
        product: productName,
        version: versionNumber,
        etUrl: `${etUrl}?product=${productName}&version=${versionNumber}${etUrlParam}`
      });
      await this.loadEtData();
    }
    return true;
  }

  async loadEtData() {
    if(process.env.NODE_ENV !== 'development') {
      await fetch(this.data.etUrl, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          page_url: this.data.pageUrl,
          referrer: this.data.referrer
        })
      })
        .then((response) => {
          if (!response.ok) {
            console.error(`shared-components Tracking: et server`, response)
            return
          }
          return response.json()
        })
        .then((body) => {
          if (!body) {
            return
          }
          this.etData = {
            sessionId: body['et-session-id'],
            userId: body['et-user-id'],
            visitId: body['et-visit-id'],
            p4etoken: body['p4e_token']
          }
          this.trackDatalayer({ user_id: this.etData.userId });
        })
        .catch((e) => {
          console.error('shared-components Tracking: et load', e);
        })
    }
  }
}
